import { useEffect, useRef } from "react";
import SvgMapper from "../../features/common/SvgMapper";
import { formatDateTime } from "../dateFormat";
import { useSelector }  from "react-redux";
import useActiveInterviews from "../../hooks/useActiveInterviews";

const UpcomingInterviews = () => {
  const { upcomingInterviews, loadMore, hasMore, loading } = useActiveInterviews();
  const scrollRef = useRef(null);

  useEffect(() => {
    if (!scrollRef.current) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      if (scrollHeight - scrollTop - clientHeight < 100 && hasMore && !loading) {
        loadMore();
      }
    };

    const container = scrollRef.current;
    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [hasMore, loading, loadMore]);

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Upcoming Interviews
      </h3>
      <div 
        ref={scrollRef}
        className="space-y-4 max-h-[400px] overflow-y-auto custom-scrollbar pr-2"
        style={{ scrollBehavior: 'smooth' }}
      >
        {upcomingInterviews.length > 0 ? (
          <>
            {upcomingInterviews.map((interview, index) => (
              <div
                key={index}
                className="flex items-center justify-between p-4 bg-yellow-50 rounded-lg"
              >
                <div className="flex items-center space-x-3">
                  <div className="p-2 bg-yellow-100 rounded-lg">
                    {SvgMapper.calendar("w-4 h-4 text-yellow-600")}
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">{interview.interview_name}</p>
                    <p className="text-sm text-gray-600">{formatDateTime(interview.active_from)} — {formatDateTime(interview.active_to)}</p>
                  </div>
                </div>
              </div>
            ))}
            
            {loading && (
              <div className="flex justify-center items-center py-4">
                <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-yellow-400"></div>
                <span className="ml-2 text-sm text-gray-600">Loading more...</span>
              </div>
            )}
            
            {!hasMore && upcomingInterviews.length > 0 && (
              <div className="text-center py-2 text-gray-500 text-sm">
                No more interviews to load
              </div>
            )}
          </>
        ) : (
          <p className="text-sm text-gray-500 italic">No upcoming interviews</p>
        )}
      </div>
    </div>
  );
};

export default UpcomingInterviews;
